import { render, staticRenderFns } from "./package-card-list.vue?vue&type=template&id=b21fb18a&scoped=true&"
import script from "./package-card-list.vue?vue&type=script&lang=js&"
export * from "./package-card-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21fb18a",
  null
  
)

export default component.exports